module.exports = __webpack_public_path__ + "img/生涯资讯.6858d177.jpg";